import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import { Message } from "mgUiKit";
import Deposit from './Deposit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TableDepositToolsListComponent';

var styles = AppSettings.styles;

class DepositToolsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            showLoading: true,
            autoExclusion: false,
            opened:false,
            details: true
        }
        this.getDepositTools = this.getDepositTools.bind(this);
        this.realod = this.realod.bind(this);
    }

    componentDidMount() {        
        this.getDepositTools();
    }

    getDepositTools(event) {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                autoExclusion: false,
                showLoading: true,
                opened: false
            });
            return;
        }        

        this.setState({
            showLoading: true,
            opened:true
        });


        this._getDepositTools();
    }

    _getDepositTools() {
        var url = AppSettings['env'].urlUserBoxGetDepositTools;
        axios.get(url)
            .then(({data, status, statusText}) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.payments,
                        autoExclusion: data.autoExclusion,
                        showLoading: showLoading,
                        
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        data: [],
                        autoExclusion: false,
                        showLoading: showLoading,
                        opened: true
                    });
                }
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "",
                    data: [],
                    showLoading: false,
                    autoExclusion: false,
                    opened: true
                });
            });
    }

    realod(){
        this.forceUpdate(()=>{
        });
    }

    renderDepositToolsList(){
        if(this.state.showLoading){
            return (
                 <CircularProgress style={styles.loadingIcon}/>
            );
        }

        var deposits = [];
        if(this.state.autoExclusion){
            deposits.push(<li>
                        <Message align="center" type="info">
                             Dal momento che è attiva un’autoesclusione non puoi effettuare operazioni di deposito. <br />
                             Per maggiori informazioni sulla configurazione dell’autoesclusione vai alla <a href="/updateaccount">pagina di gestione del tuo account</a></Message>
            </li>);
        }
        else{
            if (this.state.data.length > 0) {
                
                this.state.data.map(function (deposit, i) {
                    if(AppSettings['userSettings'].preferredDeposit.indexOf(deposit.code) != -1){
                        var key = deposit.code;
                        deposits.push(<Deposit key={key} deposit={deposit} reload={this.realod}></Deposit>);
                    }
                }.bind(this));

                this.state.data.map(function (deposit, i) {
                     if(AppSettings['userSettings'].preferredDeposit.indexOf(deposit.code) == -1){
                        var key = deposit.code;
                        deposits.push(<Deposit key={key} deposit={deposit} reload={this.realod}></Deposit>);
                    }
                }.bind(this)); 
            }
        }       

        return (  
            <>        
                <ul className="deposit-tools-list-wrap" id="money-tools-list-wrap">           
                    {deposits}
                </ul>               
            </>
        );
    }
    render() {
        return this.renderDepositToolsList();
    }
}
DepositToolsList.displayName = componentName;

// PropTypes validation
DepositToolsList.propTypes = {};

// default props
DepositToolsList.defaultProps = {};

DepositToolsList.contextTypes = {
    userboxOpened: PropTypes.bool,
    openLinkPopup: PropTypes.func
}
export default DepositToolsList;